import { useState } from 'react';
import { useCatalog, useVersions } from '../contexts/standards';

export default function MemberForm({ standard, members, busy, onAdd, onCancel }) {
    const catalog = useCatalog();
    const [standardId, setStandardId] = useState('');
    const [versionId, setVersionId] = useState('');
    const versions = useVersions(standardId);
    const options = (catalog.data ?? []).filter(item => item.id !== standard.id && item.track === standard.track && item.code !== 'tss');
    const published = (versions.data ?? []).filter(item => item.version_state === 'published');
    const existing = members.find(member => member.code === options.find(item => String(item.id) === standardId)?.code);
    return <form className="standards-editor" onSubmit={e => { e.preventDefault(); if (versionId && !busy) onAdd(Number(versionId)); }}>
        <h3>Añadir miembro al conjunto</h3>
        <p>Elige una versión publicada de la misma pista. Un conjunto reúne una versión de cada estándar.</p>
        <fieldset disabled={busy}>
            <label>Estándar miembro<select required value={standardId} onChange={e => { setStandardId(e.target.value); setVersionId(''); }}>
                <option value="">Selecciona un estándar</option>
                {options.map(item => <option key={item.id} value={item.id}>{item.name} · {item.code}</option>)}
            </select></label>
            <label>Versión del miembro<select required value={versionId} onChange={e => setVersionId(e.target.value)}>
                <option value="">Selecciona una versión publicada</option>
                {published.map(item => <option key={item.id} value={item.id}>{item.number} · ID {item.id}</option>)}
            </select></label>
        </fieldset>
        {catalog.isPending || (standardId && versions.isPending) ? <p>Cargando opciones...</p> : null}
        {(catalog.error || versions.error) && <p role="alert">{(catalog.error || versions.error).message}</p>}
        {standardId && versions.isSuccess && !published.length && <p>Este estándar todavía no tiene una versión publicada.</p>}
        {existing && <p>Esta elección reemplazará el miembro {existing.code} {existing.number} (ID {existing.version_id}).</p>}
        <div className="standards__actions"><button className="standards__primary" disabled={!versionId || busy || !!catalog.error || !!versions.error}>Guardar miembro</button><button type="button" onClick={onCancel} disabled={busy}>Cancelar</button></div>
    </form>;
}
